// extracted by mini-css-extract-plugin
module.exports = {"header":"Debug_header__2QIw5","debugSettings":"Debug_debugSettings__3abzT"};